module.exports = __webpack_public_path__ + "img/cjcl1.e7c30e68.png";